
import { Toast,Dialog } from 'vant'
// 路由
import router from '@/router';
let requestCount = 0;
const request = async(url,params,headers = {},method = "GET")=>{
    try {
        if(url.includes("api/")){
            const currentUser = JSON.parse(localStorage.getItem("currentUser")) || undefined;
            if(currentUser){
                let token = currentUser.elpToken;
                headers = {...headers,token}
            } 
        }
        if(method === "GET"){
            const keys = Object.keys(params);
            params = keys.map(key=>`${key}=${params[key]}`).join("&");
            if(params){
                requestCount++;
                Toast.loading({message: '加载中...',forbidClick: true});
                let response = await fetch(`study/${url}?${params}`,{
                    headers
                });
                //校验token
                if(url.includes("api/") && await response.clone().text() === "header") checkToken(true);
                response = await response.json();
                requestCount--;
                if(requestCount < 0){
                    requestCount = 0;
                }
                if(requestCount === 0){
                    Toast.clear();
                }
                if(response.success){
                    return response;
                }else if(response?.success === false){
                    Toast.fail(response.msg);
                    return null;
                }
            }
        }else if(method === "POST"){
            if(url === "api/elpUserExaminationQuestions/submitExamination" || url == "api/elpUserPunch-session-note/saveElpUserPunchSessionNote" || url.includes('api/elpLearningDuration/onMessage') || url == 'api/elpUserPunch/punch'){
                if(url != 'api/elpUserPunch-session-note/saveElpUserPunchSessionNote' && !url.includes('api/elpLearningDuration/onMessage')){
                    requestCount++;
                    Toast.loading({message: '加载中...',forbidClick: true});
                }
                let response = await fetch(`study/${url}`,{
                    method:"post",
                    body:JSON.stringify(params),
                    headers:{
                        ...headers,
                        "Content-Type":"application/json"
                    },
                });
                //校验token
                if(url.includes("api/") && await response.clone().text() === "header") checkToken(true);
                response = await response.json();
                if(url != 'api/elpUserPunch-session-note/saveElpUserPunchSessionNote' && !url.includes('api/elpLearningDuration/onMessage')){
                    requestCount--;
                }
                
                if(requestCount < 0){
                    requestCount = 0;
                }
                if(requestCount === 0){
                    Toast.clear();
                }
                if(response.success){
                    return response;
                }else if(response?.success === false){
                    Toast.fail(response.msg);
                    return null;
                }
            }else{
                const keys = Object.keys(params);
                let formData = new FormData();
                keys.forEach(key=>{
                    formData.append(key,params[key]);
                })
                if(!url.includes('api/elpLearningDuration/onMessage')){
                    requestCount++;
                    Toast.loading({message: '加载中...',forbidClick: true});
                }
               
                let response = await fetch(`study/${url}`,{
                    method:"post",
                    body:formData,
                    headers
                });
                //校验token
                if(url.includes("api/") && await response.clone().text() === "header") checkToken(true);
                response = await response.json();
                if(!url.includes('api/elpLearningDuration/onMessage')){
                    requestCount--;
                    if(requestCount < 0){
                        requestCount = 0;
                    }
                    if(requestCount === 0){
                        Toast.clear();
                    }
                }
                if(response.success){
                    return response;
                }else if(response?.success === false){
                    Toast.fail(response.msg);
                    return null;
                }
            }
            
        }
    } catch (error) {
        requestCount--;
        if(requestCount < 0){
            requestCount = 0;
        }
        if(requestCount === 0){
            Toast.clear();
        }
        Dialog.alert({
            title: "温馨提示",
            confirmButtonText: '关闭',
            message: "工程师正在抢修，请5分钟后刷新页面重试！",
        });
    }
    
}


 //校验token
const checkToken = (isInvalid)=>{
    if(isInvalid){
        // 清除缓存
        localStorage.removeItem("currentUser");
        // 去登陆页面
        router.push("/login");
    }
}



// 封装get请求
export const get = async (url,params) => request(url,params);

// 封装post请求
export const post = async (url,params,header) => request(url,params,header,"POST");